export const defaultInitialState = {
  personsToAttach: [],
  inputText: '',
  currentIndex: 0,
  error: null,
  result: [],
  editTranscriptMode: false,
  imagePermission: true, // Controls transcript panel visibility (Platform API)
  downloadPermission: false, // Controls download button state (Hermes API - same as ComboViewer)
  checkboxListKey: 0, // Key to recreate the CheckboxList. This is necessary because CheckboxList doesn't support changing the selected checkboxes after initial render
}

export default function reducer(state, action) {
  switch (action.type) {
    case 'ADD_PERSON_TO_ATTACH': {
      const newState = { ...state, personsToAttach: [...state.personsToAttach, action.value.personToAttach] }
      if (action.value.updateKey) {
        newState.checkboxListKey = state.checkboxListKey + 1
      }
      return newState
    }

    case 'REMOVE_PERSON_TO_ATTACH':
      return { ...state, personsToAttach: state.personsToAttach.filter((p) => p.key !== action.value) }

    case 'RESET_PERSONS_TO_ATTACH':
      return { ...state, personsToAttach: [] }

    case 'SET_INPUT_TEXT':
      return { ...state, inputText: action.value }

    case 'SET_CURRENT_INDEX':
      return { ...state, currentIndex: action.value }

    case 'SET_ERROR':
      return { ...state, error: action.value }

    case 'SET_RESULT':
      return { ...state, result: action.value }

    case 'SET_PERSONS_TO_ATTACH':
      return { ...state, personsToAttach: action.value }

    case 'SET_TRANSCRIPT_EDIT_MODE':
      return { ...state, editTranscriptMode: action.value }

    case 'RESET_FULL_TEXT_STATE':
      return defaultInitialState

    case 'SET_IMAGE_PERMISSION':
      return { ...state, imagePermission: action.value }

    case 'SET_DOWNLOAD_PERMISSION':
      return { ...state, downloadPermission: action.value }

    default:
      throw new Error(`Unhandled action type: ${action.type}`)
  }
}
